// project import
import process from './process';
import dashboard from './dashboard';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, process]
};

export default menuItems;
